import React from 'react';
import BackButton from '../components/BackButton';
import TheProof from '../components/TheProof';

function TheProofPage() {
  return (
    <>
      <BackButton />
      <TheProof />
    </>
  );
}

export default TheProofPage;
